var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.317,
    height: 55.318,
    viewBox: "0 0 55.317 55.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M5376.353,3179.5a27.659,27.659,0,1,0,27.658,27.659A27.66,27.66,0,0,0,5376.353,3179.5Zm14.76,20.468v15.111a4.146,4.146,0,0,1-4.137,4.144h-21.239a4.15,4.15,0,0,1-4.143-4.144v-15.841a4.15,4.15,0,0,1,4.143-4.143h21.239a4.137,4.137,0,0,1,4.083,3.525,3.512,3.512,0,0,1,.054.617Z",
    transform: "translate(-5348.693 -3179.5)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M5387.035,3225.678a1.4,1.4,0,0,1-.808-.255L5375.615,3218v12.408a1.15,1.15,0,0,0,1.153,1.152h20.391a1.148,1.148,0,0,0,1.146-1.152V3218.1l-10.458,7.323A1.4,1.4,0,0,1,5387.035,3225.678Z",
    transform: "translate(-5359.3 -3195.034)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M5398.313,3211.679a1.151,1.151,0,0,0-1.046-.679h-20.392a1.137,1.137,0,0,0-1.01.605l11.277,7.892Z",
    transform: "translate(-5359.409 -3192.322)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon2);
export default __webpack_public_path__ + "static/media/Email-icon2.0f5d0e803d4e39f730f386b882da605a.svg";
export { ForwardRef as ReactComponent };